import http from '@/http'

const PATH = '/customers'

function getPath (customerId) {
    return `${PATH}/${customerId}/numbers`
}

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listNumbers ({customerId, params}) {
        try {
            const response = await http.get(getPath(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, params: {}}} data
     * @returns {Promise<void>}
     */
    async showNumber ({customerId, number, params}) {
        try {
            const response = await http.get(`${getPath(customerId)}/${number}`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, params: {}}} data
     * @returns {Promise<void>}
     */
    async aliasName ({customerId, number, params}) {
        try {
            const response = await http.put(`${getPath(customerId)}/${number}/alias-name`, params)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, params: {}}} data
     * @returns {Promise<void>}
     */
    async makeAvailable ({customerId, number, params}) {
        try {
            const response = await http.put(`${getPath(customerId)}/${number}/make-available`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, params: {}}} data
     * @returns {Promise<void>}
     */
    async changeOwnership ({customerId, number, params}) {
        try {
            const response = await http.put(`${getPath(customerId)}/${number}/change-ownership`, {...params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, params: {}}} data
     * @returns {Promise<void>}
     */
    async portAway ({customerId, number, params}) {
        try {
            const response = await http.put(`${getPath(customerId)}/${number}/port-away`, {...params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listToolboxProducts ({customerId, params}) {
        try {
            const response = await http.get(`${getPath(customerId)}/toolbox`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, params: {}}} params
     * @returns {Promise<void>}
     */
    async listTechnologies ({customerId, number, params}) {
        try {
            const response = await http.get(`${getPath(customerId)}/${number}/technologies`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, technologyId: {}}} technologyId
     * @returns {Promise<void>}
     */
    async enableTechnology ({customerId, number, technologyId}) {
        try {
            const response = await http.put(`${getPath(customerId)}/${number}/technologies/enable`, {technologyId})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, technologyId: {}}} technologyId
     * @returns {Promise<void>}
     */
    async disableTechnology ({customerId, number, technologyId}) {
        try {
            const response = await http.put(`${getPath(customerId)}/${number}/technologies/disable`, {technologyId})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }

}
